import { RoomBooking } from './room-booking.model';
import { ServiceBooking } from './service-booking.model';

export class RoomBookingServiceBooking extends ServiceBooking {
  roomBooking?: RoomBooking | string;
}
